/** SVG placeholder art keyed by scene / overlay id. */

export function scenePlaceholderSvg(sceneId: string, mood: string): string {
  const palettes: Record<string, [string, string, string]> = {
    calm: ['#2a1f3d', '#5c3d2e', '#c9a227'],
    tense: ['#1a1528', '#4a2c40', '#8b5a2b'],
    chaos: ['#3d1a2a', '#6b2d5c', '#e8a317'],
    dread: ['#0f0f14', '#2a1a2a', '#4a3030'],
    triumph: ['#1f2a3d', '#3d5c4a', '#d4af37'],
  };
  const [a, b, c] = palettes[mood] ?? palettes.tense;
  return `data:image/svg+xml,${encodeURIComponent(`<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 800 450">
  <defs>
    <linearGradient id="g" x1="0" y1="0" x2="1" y2="1">
      <stop offset="0%" stop-color="${a}"/>
      <stop offset="50%" stop-color="${b}"/>
      <stop offset="100%" stop-color="${c}"/>
    </linearGradient>
    <radialGradient id="glow" cx="50%" cy="30%" r="60%">
      <stop offset="0%" stop-color="#fff8e7" stop-opacity="0.35"/>
      <stop offset="100%" stop-color="#000" stop-opacity="0"/>
    </radialGradient>
  </defs>
  <rect width="800" height="450" fill="url(#g)"/>
  <ellipse cx="400" cy="120" rx="280" ry="100" fill="url(#glow)"/>
  <text x="400" y="380" text-anchor="middle" fill="#f5e6c8" font-family="Georgia,serif" font-size="22" opacity="0.85">${sceneId.replace('s', 'Scene ')}</text>
  <text x="400" y="410" text-anchor="middle" fill="#c9a227" font-family="sans-serif" font-size="12" opacity="0.6">${mood}</text>
</svg>`)}`;
}

export function cardPlaceholderSvg(name: string, hue: number): string {
  return `data:image/svg+xml,${encodeURIComponent(`<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 200 280">
  <defs>
    <linearGradient id="c" x1="0" y1="0" x2="1" y2="1">
      <stop offset="0%" stop-color="hsl(${hue},45%,22%)"/>
      <stop offset="100%" stop-color="hsl(${hue},55%,12%)"/>
    </linearGradient>
  </defs>
  <rect width="200" height="280" rx="12" fill="url(#c)" stroke="#c9a227" stroke-width="2"/>
  <rect x="16" y="16" width="168" height="120" rx="8" fill="#000" opacity="0.25"/>
  <text x="100" y="200" text-anchor="middle" fill="#f5e6c8" font-family="Georgia,serif" font-size="14">${name.slice(0, 18)}</text>
</svg>`)}`;
}
